const api = {
    bestRetedURL: "https://api.jikan.moe/v4/top/anime",
    upcomingAnimeURL: "https://api.jikan.moe/v4/seasons/upcoming",
    schedulesURL: "https://api.jikan.moe/v4/schedules?page=6",
    fallSeasonsURL: "https://api.jikan.moe/v4/seasons/2023/fall",
    randomAnimeURL: "https://api.jikan.moe/v4/random/anime",
    topReviewsURL: 'https://api.jikan.moe/v4/reviews/anime',
};

export const {
    bestRetedURL,
    upcomingAnimeURL,
    schedulesURL,
    fallSeasonsURL,
    randomAnimeURL,
    topReviewsURL,
} = api;
